import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { SupplierResource } from "@exonn/js-sdk";

export const module: Module<SupplierResource> = {
  id: ResourceEnum.Supplier,
  bigIcon: <i className="icon-20-suppliers" />,
  smallIcon: <i className="icon-15-suppliers" />,
  name: (t: TFunction) => t("moduleName.suppliers"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.number,
    },
  },
};
